import type { TopLinkItemType } from "./types";

export const footerMenu: TopLinkItemType[] = [
    {
        title: "Planning Tools", url: "/planning-tools/", submenu: [
            { title: "To Do List", url: "/planning-tools/to-do-list/", loggedInUrl: "/tools/todolist/" },
            { title: "Guest List", url: "/planning-tools/guest-list/", loggedInUrl: "/tools/guestlist/" },
            { title: "Seating Planner", url: "/planning-tools/seating-planner/", loggedInUrl: "/tools/seatingplanner/" },
            { title: "Budget Calculator", url: "/planning-tools/budget-calculator/", loggedInUrl: "/tools/budgetcalculator/" },
        ]
    },
    {
        title: "Suppliers", url: "/wedding/", submenu: [
            { title: "Wedding Venues", url: "/WeddingVenues/" },
            { title: "Dresses", url: "/WeddingDress/" },
            { title: "Photography", url: "/WeddingPhotography/" },
            { title: "Celebrants", url: "/MarriageCelebrant/" },
            { title: "Cars", url: "/WeddingCars/" },
            { title: "Hair and Makeup", url: "/WeddingHair/" },
            { title: "Wedding Packages", url: "/packages/", country: "au" },
        ]
    },
    {
        title: "Packages", country: "au", submenu: [
            { title: "Wedding Packages", url: "/packages/" },
            { title: "Destination Weddings", url: "/destination-weddings/" },
        ]
    },
    {
        title: "Help", submenu: [
            { title: "Advice & Ideas", url: "/articles/" },
            { title: "Ask a Question", url: "/advice/" },
            { title: "Contact Us", url: "/contact/" },
        ]
    },
]
